export function CoursesSection() {
  const courses = [
    {
      title: 'Estrategias Publicitarias Avanzadas',
      badge: 'Facebook Ads',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/5b48623fddede62d80f792b21cc2f915.jpeg'
    },
    {
      title: 'Venta por WhatsApp',
      badge: 'Conversión',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/35e796b5b6727cd830e10b20f159531c.jpeg'
    },
    {
      title: 'Embudos y VSL y Páginas de Alta Conversión',
      badge: 'Funnels',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/95c097ee04be1553a1ddc69469677698.jpeg'
    },
    {
      title: 'Clases en VIVO',
      badge: 'Exclusivo',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/9fc0135a95f2545edfcc07ab4d96091f.jpeg',
      special: true
    },
    {
      title: 'Comunidad Privada',
      badge: 'Soporte 24/7',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/ce2ff3d164cf4b73b18d219ecc44858b.jpeg'
    }
  ];

  return (
    <section id="cursos" className="py-24 bg-gradient-to-br from-slate-50 via-purple-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">Qué incluye tu acceso</h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Acceso completo a todos los cursos y soporte que necesitas para comenzar a vender desde el primer día
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <div
              key={index}
              className={`group rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer ${
                course.special ? 'bg-gradient-to-br from-gray-900 to-slate-800' : 'bg-white'
              }`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  alt={course.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src={course.image}
                />
                <div
                  className={`absolute top-4 left-4 px-4 py-1.5 rounded-full text-sm font-bold whitespace-nowrap ${
                    course.special
                      ? 'bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900'
                      : 'bg-gradient-to-r from-emerald-500 to-cyan-500 text-white'
                  }`}
                >
                  {course.badge}
                </div>
              </div>
              <div className="p-6">
                <h3 className={`text-xl font-bold mb-3 ${course.special ? 'text-white' : 'text-gray-900'}`}>
                  {course.title}
                </h3>
                <div
                  className={`flex items-center gap-2 ${
                    course.special ? 'text-emerald-400' : 'text-emerald-600'
                  }`}
                >
                  <i className="ri-play-circle-line text-xl"></i>
                  <span className="text-sm font-medium whitespace-nowrap">Acceso inmediato</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-4 gap-8">
          <div className="text-center p-6 rounded-2xl bg-white shadow-md">
            <div className="text-5xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
              500+
            </div>
            <div className="text-gray-600 text-sm mt-1 whitespace-nowrap">Estudiantes Activos</div>
          </div>
          <div className="text-center p-6 rounded-2xl bg-white shadow-md">
            <div className="text-5xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
              4.9/5
            </div>
            <div className="text-gray-600 text-sm mt-1 whitespace-nowrap">Calificación Promedio</div>
          </div>
          <div className="text-center p-6 rounded-2xl bg-white shadow-md">
            <div className="text-5xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
              95%
            </div>
            <div className="text-gray-600 text-sm mt-1 whitespace-nowrap">Tasa de Satisfacción</div>
          </div>
          <div className="text-center p-6 rounded-2xl bg-white shadow-md">
            <div className="text-5xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
              24/7
            </div>
            <div className="text-gray-600 text-sm mt-1 whitespace-nowrap">Soporte Disponible</div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-2xl font-bold text-gray-900 mb-2">
            Puedes acceder desde <span className="text-emerald-600">S/70 De por vida</span>
          </p>
        </div>
      </div>
    </section>
  );
}
